document.addEventListener('click', (e) => {
  const btn = e.target.closest('.uswe-quick-add');
  if (!btn) return;
  e.preventDefault();

  const variantId = parseInt(btn.dataset.variant, 10);
  if (!variantId) {
    console.error("No variant ID found");
    return;
  }

  const productHandle = btn.dataset.productHandle;
  if (!productHandle) {
    console.error("No product handle found");
    return;
  }

  // Fetch product JSON to check availability
  fetch(`/products/${productHandle}.js`)
    .then(res => res.json())
    .then(product => {
      // Count how many variants are available
      const availableVariants = product.variants.filter(v => v.available);

      if (availableVariants.length > 1) {
        // If more than one option is available, redirect to product page
        window.location.href = product.url;
        return;
      }

      // If only one option is available, quick add it
      quickAdd(variantId, btn);
    })
    .catch(err => {
      console.error("Error fetching product JSON", err);
      quickAdd(variantId, btn); // fallback
    });
});

function quickAdd(variantId, btn) {
  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then(res => {
      if (!res.ok) return res.json().then(err => Promise.reject(err));
      return res.json();
    })
    .then(() => {
      btn.textContent = 'Added';

      if (typeof cart !== 'undefined' && typeof cart.getCart === 'function') {
        cart.getCart().then(() => {
          const cartToggle = document.querySelector('.js-cart-toggle, .iCartBtnToggle');
          if (cartToggle) cartToggle.click();
        });
      } else {
        location.reload();
      }
    })
    .catch(err => {
      console.error('Add to cart failed', err);
      btn.textContent = 'Error';
    })
    .finally(() => {
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1200);
    });
}
